import { HttpHeaders } from '@angular/common/http';

export class appSettings {
   public static API_ENDPOINT_PLATFORM = 'https://be.myaccount.afhunt.com/api/';
   public static API_ENDPOINT_BASE = 'https://be.myaccount.afhunt.com/';
   public static RESOURCE_URL_BASE = 'https://be.myaccount.afhunt.com/';

   public static httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
   };
}
